
import { useState } from "react";
import { cn } from "@/lib/utils";

interface TimePreferenceSectionProps {
  selectedDateId: string | null;
  timeOfDay: string | undefined;
  selectedTimePreference: string | undefined;
  onTimePreferenceSelect: (preference: string, label: string) => void;
}

export const TimePreferenceSection = ({
  selectedDateId,
  timeOfDay,
  selectedTimePreference,
  onTimePreferenceSelect
}: TimePreferenceSectionProps) => {
  // Only show the section if a date is selected
  if (!selectedDateId) return null;

  // Define time options based on time of day
  const getTimeOptions = () => {
    if (!timeOfDay) return [];
    
    switch (timeOfDay.toLowerCase()) {
      case 'morning':
        return [
          { value: 'early_morning', label: '8am or earlier' },
          { value: 'mid_morning', label: 'Around 9am' },
          { value: 'late_morning', label: '10am or later' }
        ];
      case 'afternoon':
        return [
          { value: 'early_afternoon', label: '12pm or earlier' },
          { value: 'mid_afternoon', label: 'Around 1pm' },
          { value: 'late_afternoon', label: '2pm or later' }
        ];
      case 'evening':
        return [
          { value: 'early_evening', label: '6pm or earlier' },
          { value: 'mid_evening', label: 'Around 7pm' },
          { value: 'late_evening', label: '8pm or later' }
        ];
      default:
        return [];
    }
  };

  const timeOptions = getTimeOptions();
  
  // If no time options are available, don't render anything
  if (timeOptions.length === 0) return null;

  return (
    <div className="space-y-4 px-4 mt-6">
      <h3 className="text-sm font-light">Preferred Time</h3>
      <div className="flex flex-wrap gap-2">
        {timeOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            className={cn(
              "px-4 py-2 text-sm rounded-full border transition-colors",
              selectedTimePreference === option.value
                ? "bg-primary text-primary-foreground border-primary" 
                : "bg-background border-muted-foreground/20 hover:border-muted-foreground/40"
            )}
            onClick={() => onTimePreferenceSelect(option.value, option.label)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
